export default "__VITE_ASSET__BARQh7Wc__"